type SearchInput = Record<string, unknown>;

export type UserListSearch = {
  endAt?: string;
  limit?: number;
  orderBy?: string;
  paid?: string;
  page?: number;
  search?: string;
  startAt?: string;
};

export type CompanyListSearch = {
  companyPaid?: string;
  limit?: number;
  orderBy?: string;
  page?: number;
  search?: string;
};

export type ProjectListSearch = {
  limit?: number;
  page?: number;
  project?: string;
  search?: string;
};

const positiveInteger = (value: unknown, fallback: number): number => {
  const parsed = typeof value === "number" ? value : Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback;
};

const optionalString = (value: unknown): string | undefined => {
  if (typeof value !== "string" || value.length === 0) return undefined;
  return value;
};

export function validateAdminParams<T extends Record<string, string>>(
  params: T,
): T {
  for (const [name, value] of Object.entries(params)) {
    if (value.length === 0)
      throw new Error(`Route parameter ${name} is required`);
  }
  return params;
}

export function validateUserListSearch(search: SearchInput): UserListSearch {
  return {
    limit: positiveInteger(search.limit, 10),
    page: positiveInteger(search.page, 1),
    orderBy: optionalString(search.orderBy),
    paid: optionalString(search.paid),
    search: optionalString(search.search),
    startAt: optionalString(search.startAt),
    endAt: optionalString(search.endAt),
  };
}

export function validateCompanyListSearch(
  search: SearchInput,
): CompanyListSearch {
  return {
    companyPaid: optionalString(search.companyPaid),
    limit: positiveInteger(search.limit, 10),
    orderBy: optionalString(search.orderBy),
    page: positiveInteger(search.page, 1),
    search: optionalString(search.search),
  };
}

export function validateProjectListSearch(
  search: SearchInput,
): ProjectListSearch {
  return {
    limit: positiveInteger(search.limit, 10),
    page: positiveInteger(search.page, 1),
    project: optionalString(search.project),
    search: optionalString(search.search),
  };
}
